var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_29_609",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_29_609)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9364 21.7161L21.6524 16.0001L15.9364 10.2841L13.8144 12.4138L15.884 14.4834H10.4197V17.5168H15.884L13.8144 19.5864L15.9364 21.7161ZM16 29.6044C14.1131 29.6044 12.3427 29.2475 10.6887 28.5338C9.03447 27.82 7.59558 26.8514 6.37202 25.6281C5.14869 24.4045 4.18014 22.9656 3.46636 21.3114C2.75258 19.6574 2.39569 17.887 2.39569 16.0001C2.39569 14.1132 2.75258 12.3428 3.46636 10.6888C4.18014 9.03453 5.14869 7.59564 6.37202 6.37208C7.59558 5.14875 9.03447 4.1802 10.6887 3.46642C12.3427 2.75264 14.1131 2.39575 16 2.39575C17.8869 2.39575 19.6574 2.75264 21.3114 3.46642C22.9656 4.1802 24.4045 5.14875 25.628 6.37208C26.8514 7.59564 27.8199 9.03453 28.5337 10.6888C29.2475 12.3428 29.6044 14.1132 29.6044 16.0001C29.6044 17.887 29.2475 19.6574 28.5337 21.3114C27.8199 22.9656 26.8514 24.4045 25.628 25.6281C24.4045 26.8514 22.9656 27.82 21.3114 28.5338C19.6574 29.2475 17.8869 29.6044 16 29.6044ZM16 26.5711C18.9565 26.5711 21.4575 25.5484 23.503 23.5031C25.5484 21.4575 26.571 18.9565 26.571 16.0001C26.571 13.0436 25.5484 10.5426 23.503 8.49708C21.4575 6.45175 18.9565 5.42909 16 5.42909C13.0436 5.42909 10.5426 6.45175 8.49702 8.49708C6.45169 10.5426 5.42902 13.0436 5.42902 16.0001C5.42902 18.9565 6.45169 21.4575 8.49702 23.5031C10.5426 25.5484 13.0436 26.5711 16 26.5711Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/rightArrow.9c4f0c3fce4dd217c0e2a0239ebce1d5.svg";
export { ForwardRef as ReactComponent };